import {createReducer} from '@reduxjs/toolkit';
import {cleanEventInfo} from 'src/modules/event/services/actions';
import {getEventByIdSuccess} from 'src/openapi/apis/EventControllerApi';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

type State = {
    data: Record<string, EventDetailInfo>,
};

const defaultState = {
    data: {},
};

export const eventInfo = createReducer<State>(defaultState, builder => builder
    .addCase(getEventByIdSuccess, (state, action) => {
        state.data = {...state.data, [action.payload.data.id]: action.payload.data};
    })
    .addCase(cleanEventInfo, state => {
        state.data = {};
    }),
);
